// Syracuse University's undergraduate majors (#2652). Read on 2026-10-01 from
// the official Syracuse University Course Catalog, 2026-2027 edition
// (coursecatalog.syracuse.edu/undergraduate/<college>/, each college's
// Programs tab): every bachelor's major listed under "Major". Left out:
// minors, certificates, combined (BS/MS, BS/MBA, 4+1) and dual degrees,
// programs marked "Not Admitting Students", the College of Professional
// Studies (part-time and adult programs, not one of the nine colleges
// first-year applicants apply to) and SUNY-ESF (a partner institution).
// Maxwell School majors sit under the College of Arts and Sciences in the
// catalog's paths and are listed there. Flags quote Syracuse's
// College-Specific Requirements page (the college file's `programs`
// source). Typography is plain ASCII. The KB's majors list was the starting
// point; the catalog wins.
const majors = {
    "slug": "syracuse-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major in Syracuse's official 2026-2027 Course Catalog, grouped by the college that offers it, with the degree it leads to. Maxwell School majors appear with the College of Arts and Sciences, as the catalog lists them. Minors, combined and dual degrees, programs not admitting students and graduate programs are left out.",
    "groups": [
        {
            "name": "School of Architecture",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, School of Architecture",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/architecture/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "B.Arch",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, College of Arts and Sciences",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/arts-sciences/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Communication Sciences and Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English and Textual Studies",
                    "degree": "BA"
                },
                {
                    "name": "Environment, Sustainability, and Policy",
                    "degree": "BA"
                },
                {
                    "name": "Environment, Sustainability, and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Geoscience",
                    "degree": "BS"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Health Humanities",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "BS"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BS"
                },
                {
                    "name": "Law, Society, and Policy",
                    "degree": "BA"
                },
                {
                    "name": "Linguistic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Music History and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Policy Studies",
                    "degree": "BA"
                },
                {
                    "name": "Political Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Selected Studies in Arts and Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Selected Studies in Arts and Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish Language, Literature and Culture",
                    "degree": "BA"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Writing and Rhetoric",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, School of Education",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/education/"
            },
            "majors": [
                {
                    "name": "Education and Society",
                    "degree": "BS"
                },
                {
                    "name": "Inclusive Adolescent Education",
                    "degree": "BS"
                },
                {
                    "name": "Inclusive Childhood Education",
                    "degree": "BS"
                },
                {
                    "name": "Music Education",
                    "degree": "BMus",
                    "flag": "An audition is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Social Work",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering and Computer Science",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, College of Engineering and Computer Science",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/engineering-computer-science/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Artificial Intelligence Science",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                }
            ],
            "note": "Applicants send one academic recommendation from a STEM teacher.",
            "noteSource": "programs"
        },
        {
            "name": "School of Information Studies",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, School of Information Studies",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/information-studies/"
            },
            "majors": [
                {
                    "name": "Applied Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Information Management and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Integrative Artificial Intelligence",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Martin J. Whitman School of Management",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, Martin J. Whitman School of Management",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/management/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurship and Emerging Enterprises",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "General Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing Management",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate",
                    "degree": "BS"
                },
                {
                    "name": "Retail Management",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "S.I. Newhouse School of Public Communications",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, S.I. Newhouse School of Public Communications",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/public-communications/"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BS"
                },
                {
                    "name": "Esports Communications & Management",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Public Relations",
                    "degree": "BS"
                },
                {
                    "name": "Recording and Entertainment Industries",
                    "degree": "BS"
                },
                {
                    "name": "Strategic Communications",
                    "degree": "BS"
                },
                {
                    "name": "Television, Radio and Film",
                    "degree": "BS"
                },
                {
                    "name": "Visual Communications",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "David B. Falk College of Sport",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, David B. Falk College of Sport",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/sport/"
            },
            "majors": [
                {
                    "name": "Health and Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Sport Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Esports Communications & Management",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Visual and Performing Arts",
            "source": {
                "label": "Syracuse University Course Catalog 2026-2027, College of Visual and Performing Arts",
                "url": "https://coursecatalog.syracuse.edu/undergraduate/visual-performing-arts/"
            },
            "majors": [
                {
                    "name": "Communication and Rhetorical Studies",
                    "degree": "BS"
                },
                {
                    "name": "Acting",
                    "degree": "BFA",
                    "flag": "A prescreen audition is required, and early decision and early action are not open to this program.",
                    "flagSource": "programs"
                },
                {
                    "name": "Drama",
                    "degree": "BS",
                    "flag": "An audition or portfolio is required for Department of Drama programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Musical Theater",
                    "degree": "BFA",
                    "flag": "A prescreen audition is required, and early decision and early action are not open to this program.",
                    "flagSource": "programs"
                },
                {
                    "name": "Stage Management",
                    "degree": "BFA",
                    "flag": "An audition or portfolio is required for Department of Drama programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Theater Design and Technology",
                    "degree": "BFA",
                    "flag": "An audition or portfolio is required for Department of Drama programs.",
                    "flagSource": "programs"
                },
                {
                    "name": "Art Photography",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Film",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Illustration and Animation",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Studio Arts",
                    "degree": "BS"
                },
                {
                    "name": "Communications Design",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Design Futures",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Interior Design",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Fashion Design",
                    "degree": "BFA",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Industrial and Interaction Design",
                    "degree": "B.I.D.",
                    "flag": "A portfolio is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Composition",
                    "degree": "BMus"
                },
                {
                    "name": "Music Education",
                    "degree": "BMus",
                    "flag": "An audition is required.",
                    "flagSource": "programs"
                },
                {
                    "name": "Music Industry",
                    "degree": "BMus"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Sound Recording Technology",
                    "degree": "BMus"
                }
            ]
        }
    ]
};

export default majors;
